// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__MgzMK","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1ItYI","obliqueLine":"membershipbadge_obliqueLine__2Wbxh"};